import ApiService from './ApiService.js'
import ApiHelper from './ApiHelper.js'

export default {
    getByID(id) {
        let header = ApiHelper.getHeader();
        return ApiService().get('/api/statuses/' + id,
            { 
                headers: header
            });
    }
}